import React, { useRef, useState } from "react";
import { Button, ConfigProvider, Divider, Input, Modal, Radio, TimePicker } from "antd";
import AddLinkIcon from "@mui/icons-material/AddLink";
import { useJsApiLoader, Autocomplete, } from '@react-google-maps/api'
import dayjs from "dayjs";


const AddEditAddresses = ({ editCustomerAddress, handleCustomerAddressEditClose, saveAddressLoading, saveCustomerAddress, setEditCustomerAddress }) => {

    const [libraries] = useState(['places']);
    const { isMapsServiceLoaded } = useJsApiLoader({
        googleMapsApiKey: "AIzaSyCKT6hm3CTWMFr56LLdsXUjlZpFHY6ihUs",
        libraries: libraries,
    })

    const autocompleteRef = useRef();

    return (
        <div>
            <Modal
                title={`Add/Edit Customer Delivery Address/Time`
                }
                open={editCustomerAddress?.open}
                onCancel={handleCustomerAddressEditClose}
                centered
                width={650}
                maskClosable={false}
                footer={< div className="flex justify-end" >
                    <div className="flex justify-between">
                        <div>

                        </div>
                        <div>
                            <ConfigProvider
                                theme={{
                                    components: {
                                        Button: {
                                            defaultHoverColor: "#ffffff",
                                            defaultHoverBg: "#3be368",
                                            defaultBg: "#31bd56",
                                        },
                                    },
                                }}
                            >

                                <Button
                                    endIcon={<AddLinkIcon />}
                                    variant="contained"
                                    onClick={() => saveCustomerAddress()}
                                    loading={saveAddressLoading}
                                >
                                    Save
                                </Button>
                            </ConfigProvider>
                        </div>
                    </div>
                </div >}>
                <div className="gap-2 grid border rounded drop-shadow p-2" style={{ backgroundColor: "#f7f7f7" }}>


                    <div className="border rounded p-2 gap-2 grid overflow-y-auto" style={{ backgroundColor: "#fbfbfb", maxHeight: "50vh" }}>
                        <div className="flex gap-2">

                            <Input
                                allowClear
                                placeholder="Name of the person *"
                                value={editCustomerAddress?.data?.name || null}
                                onChange={(e) => {
                                    setEditCustomerAddress(prev => ({
                                        ...prev,
                                        data: {
                                            ...prev.data,
                                            name: e.target.value,
                                        },
                                    }));
                                }}
                            />

                            <Input
                                allowClear
                                placeholder="Number of the person *"
                                value={editCustomerAddress?.data?.number || null}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/[^0-9]/g, ''); // Strip all non-numeric chars

                                    setEditCustomerAddress(prev => ({
                                        ...prev,
                                        data: {
                                            ...prev.data,
                                            number: value,
                                        },
                                    }));
                                }}
                            />

                        </div>

                        <div>
                            <Autocomplete
                                onLoad={(autocompleteInstance) => {
                                    autocompleteRef.current = autocompleteInstance;
                                }}
                                onPlaceChanged={() => {
                                    if (!autocompleteRef.current) return;

                                    const place = autocompleteRef.current.getPlace();
                                    if (place?.formatted_address) {
                                        setEditCustomerAddress((prev) => ({
                                            ...prev,
                                            data: { ...prev.data, address: place.formatted_address },
                                        }));
                                    }
                                }}
                            >
                                <Input
                                    allowClear
                                    placeholder="Address *"
                                    value={editCustomerAddress?.data?.address || ""}
                                    onChange={(e) => {
                                        setEditCustomerAddress((prev) => ({
                                            ...prev,
                                            data: {
                                                ...prev.data,
                                                address: e.target.value,
                                            },
                                        }));
                                    }}
                                />
                            </Autocomplete>
                        </div>

                        <div className="flex items-center gap-1">
                            <span>Preferred Delivery Time :</span>
                            <span>
                                <TimePicker.RangePicker
                                    value={editCustomerAddress?.data?.pref_time ? [dayjs(editCustomerAddress?.data?.pref_time[0] || new Date()), dayjs(editCustomerAddress?.data?.pref_time[1] || new Date())] : null}
                                    format="hh:mmA"
                                    allowClear
                                    onChange={(e) => {
                                        setEditCustomerAddress(prev => ({
                                            ...prev,
                                            data: {
                                                ...prev.data,
                                                pref_time: e,
                                            },
                                        }));
                                    }}
                                />
                            </span>
                            <Divider style={{ color: "black" }} plain type="vertical" />
                            <span>
                                <Radio.Group
                                    value={editCustomerAddress?.data?.type || null}
                                    block
                                    options={[{ label: "Home", value: "Home" }, { label: "Office", value: "Office" }]}
                                    defaultValue="Home"
                                    optionType="button"
                                    buttonStyle="solid"
                                    onChange={(e) => {
                                        setEditCustomerAddress(prev => ({
                                            ...prev,
                                            data: {
                                                ...prev.data,
                                                type: e.target.value,
                                            },
                                        }));
                                    }}
                                />
                            </span>
                        </div>

                    </div>


                </div>
            </Modal >
        </div>
    );
}

export default AddEditAddresses;